import React from 'react';
import {Nav, Tab} from "react-bootstrap";
import {useSelector} from "react-redux";
import OverviewTab from "../../../Resident/tabs/OverviewTab";
import FacilitiesTab from "../tabs/FacilitiesTab";
import NotesTab from "../tabs/NotesTab";
import DocumentsTab from "../tabs/DocumentsTab";
import FormRequestsTab from '../tabs/FormRequestsTab';
import FormSubmissionsTab from '../tabs/FormSubmissionsTab';
import FormSubmissionsTabFSARR from "../tabs/FormSubmissionsTabFSARR";
import InspectionsTab from "../tabs/InspectionsTab";
const tabs = [
  {
    label: 'Facilities',
    value: 'facilities',
  },
  {
    label: 'Form Requests',
    value: 'form_requests',
  },
  {
    label: 'Form Submissions',
    value: 'form_submissions',
  },
  {
    label: 'Inspections',
    value: 'inspections',
  },
  // {
  //   label: 'Notes',
  //   value: 'notes',
  // },
  // {
  //   label: 'Documents',
  //   value: 'documents',
  // }
]

const AffiliateMemberTabs = () => {
  const [tabKey, setTabKey] = React.useState('facilities');
  const { organization } = useSelector((state) => state);

  return (
    <Tab.Container
      activeKey={tabKey}
      onSelect={(tabKey) => setTabKey(tabKey)}
    >
      <Nav variant="tabs">
        {tabs.map((tab) => {
          return (
            <Nav.Item key={tab.value}>
              <Nav.Link eventKey={tab.value}>{tab.label}</Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="facilities" title="Facilities">
          <FacilitiesTab />
        </Tab.Pane>
        <Tab.Pane eventKey="form_requests" title="Form Requests">
          <FormRequestsTab />
        </Tab.Pane>
        <Tab.Pane eventKey="form_submissions" title="Form Submissions">
          <FormSubmissionsTabFSARR />
        </Tab.Pane>
        <Tab.Pane eventKey="inspections" title="Inspections">
          <InspectionsTab />
        </Tab.Pane>
        {/*<Tab.Pane eventKey="notes" title="Notes">*/}
        {/*  <NotesTab/>*/}
        {/*</Tab.Pane>*/}
        {/*<Tab.Pane eventKey="documents" title="Documents">*/}
        {/*  <DocumentsTab/>*/}
        {/*</Tab.Pane>*/}
      </Tab.Content>
    </Tab.Container>
  );
}

export default AffiliateMemberTabs;
